import React from "react"

/* importing custom modules */
import SubscribeForm from '../Custom Modules/SubscribeBlog.js'
import Badge from '../Material-UI-Components/Badge';

export default function SubscribeFloatingButton(){

  const [floatingSubscribeForm, setFloatingSubscribeForm] = React.useState();


  const handleFloatingSubscribeForm = (value) =>{
    setFloatingSubscribeForm(value);
  };

  return(
    <div>
    {floatingSubscribeForm?
        <div>
          <div className="floatingContactForm">
            <div className="width100 mgbt40">
              <SubscribeForm/>
            </div>
          </div>
        </div>
        :
    <div></div>}
          <div className="floatingQueryFormButton">
            <Badge 
                type={'floatingIcon'} 
                badgeContent={'Subscribe'}
                handleFloatingContactForm={handleFloatingSubscribeForm}
                floatingContactForm = {floatingSubscribeForm}
            />
          </div> 
  </div>
)
}